module.exports = __webpack_public_path__ + "img/logo.2b22fd53.png";